export const CREATE_CALLING_LIST_LIMIT = 2000;
